import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CtaBlock } from '../CtaBlock';
import { Countdown } from '../Countdown';
const badges = ['Accesso digitale immediato', 'Pagamento una tantum', 'Accesso a vita', 'Garanzia di 7 giorni'];
export function Hero() {
  return <header className="w-full bg-cream px-4 pb-12 pt-8 sm:px-6 sm:pb-16 sm:pt-10" data-id="element-197" data-mp="huo264m5giri">
      <div className="mx-auto max-w-3xl text-center" data-id="element-198" data-mp="hsl3yxaufjbp">
        <div className="mb-7 flex items-center justify-center gap-2" data-id="element-199" data-mp="mt91m1tkuyew">
          <span className="font-display text-lg font-bold tracking-tight text-navy" data-id="element-200" data-mp="qv40kzo1czpi">Dr.ssa Karito</span>
          <span className="h-1.5 w-1.5 rounded-full bg-brand" aria-hidden="true" data-id="element-201" data-mp="vm2ksac5ahy1" />
          <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-navy/50" data-id="element-202" data-mp="10l5ptus4ko60">Clinical Systems</span>
        </div>

        <h1 className="font-display text-[30px] font-bold leading-[1.1] tracking-tight text-navy sm:text-5xl" data-id="element-203" data-mp="15ll3yok8dzp1">
          Smetti di andare a tentativi.
          <span className="mt-1 block italic text-brand" data-id="element-204" data-mp="1ah8pmtzi8aps">Pianifica come un esperto.</span>
        </h1>

        <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-navy/70 sm:text-lg" data-id="element-205" data-mp="4optc945k57a">
          Scopri esattamente cosa controllare in ogni fase del trattamento con allineatori per ridurre i refinements
          evitabili, prevenire errori di pianificazione e affrontare ogni caso con maggiore sicurezza.
        </p>

        <div className="-mx-4 mt-8 sm:mx-0" data-id="element-206" data-mp="sek48l4wvjow">
          <img src="https://cdn.magicpatterns.com/uploads/v1RNjVwhCFp1HiCyuWakuv/DENTISTAS-IT.png" alt="Il Sistema Maestro di Pianificazione con Allineatori — sei volumi clinici su desktop, tablet e smartphone" className="mx-auto w-full max-w-[620px]" width={1080} height={1080} data-id="element-207" data-mp="sdiwoqn3tfbx" />
        </div>

        <h2 className="mt-6 font-display text-xl font-bold leading-snug text-navy sm:text-2xl" data-id="element-208" data-mp="1b5tptsryhywu">
          Il Sistema Maestro di Pianificazione con Allineatori™
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-[15px] leading-relaxed text-navy/70" data-id="element-209" data-mp="30m72tvcbue1c">
          Una biblioteca clinica completa con <strong className="text-navy" data-id="element-210" data-mp="35jyyn0g3ekat">6 volumi specializzati</strong> +{' '}
          <strong className="text-navy" data-id="element-211" data-mp="2qwnmawc36w9n">5 bonus esclusivi</strong> per pianificare, analizzare, eseguire e finalizzare i
          casi con allineatori attraverso un sistema clinico strutturato.
        </p>

        <ul className="mx-auto mt-6 grid max-w-md grid-cols-2 gap-2 text-left" data-id="element-212" data-mp="2hv69pnxw1cpp">
          {badges.map(badge => <li key={badge} className="flex items-start gap-1.5 rounded-xl bg-white px-3 py-2.5 text-[12px] font-semibold leading-tight text-navy shadow-[0_2px_10px_-6px_rgba(15,37,71,0.4)] sm:text-[13px]" data-id="element-213" data-mp="2mvk9yjt8zid6">
              <CheckIcon className="mt-[1px] h-3.5 w-3.5 shrink-0 text-brand" aria-hidden="true" data-id="element-214" data-mp="2cy60j45qrtud" />
              {badge}
            </li>)}
        </ul>

        <div className="mt-8" data-id="element-215" data-mp="b4g8zon2mnex">
          <CtaBlock id="hero-cta" label="Accedi subito — €19" note="" data-id="element-216" data-mp="b2lx0zts25mz" />
          <div className="mt-4 flex flex-col items-center gap-3" data-id="element-217" data-mp="1vnk4cxqanv65">
            <Countdown data-id="element-218" data-mp="1qopan0qsgm79" />
            <p className="flex items-center justify-center gap-1.5 text-[12px] font-medium text-navy/60" data-id="element-219" data-mp="1qpii63xknfqg">
              <GlobeIcon className="h-3.5 w-3.5 text-navy/40" aria-hidden="true" data-id="element-220" data-mp="25e4wq3fdk3gm" />
              Il cambio di valuta è automatico: paghi nella tua valuta locale.
            </p>
          </div>
        </div>

        <p className="mt-8 text-[11px] font-bold uppercase tracking-[0.16em] text-navy/40" data-id="element-221" data-mp="2ebp29ok9slx1">
          Utilizzato da professionisti in oltre 20 Paesi
        </p>
      </div>
    </header>;
}